import { useLocation, useNavigate } from 'react-router-dom';
import AddPlayersStepV2 from '../../myLeagues/components/steps/AddPlayersStepV2';

interface AddPlayersLocationState {
  tournamentId?: string;
  leagueId?: string;
}

const AddPlayersPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state ?? {}) as AddPlayersLocationState;

  const tournamentId =
    state.tournamentId?.trim() || sessionStorage.getItem('tournamentId') || '';
  const leagueId =
    state.leagueId?.trim() || sessionStorage.getItem('leagueId') || '';

  const handleDone = () => navigate(-1);

  return (
    <div
      style={{
        padding: '140px 24px 48px',
        maxWidth: 1320,
        margin: '30px auto',
        fontFamily: '"Inter-300", "Inter", system-ui, sans-serif',
      }}
    >
      <AddPlayersStepV2
        leagueId={leagueId || null}
        tournamentId={tournamentId || null}
        teamSnapshots={null}
        onNext={handleDone}
      />
    </div>
  );
};

export default AddPlayersPage;
